import i18n from "shared/i18n";

export const addLang = url => {
  const currentLang = i18n.language;
  if(!currentLang || typeof currentLang === 'undefined' ){
    return `/api/v1/${url}`;
  }
  return `${currentLang.slice(0,2)}/api/v1/${url}`;
};
